import type { Components } from '@/api/generated/api';
import { getHasTenantOwnerAccess } from '@/utils/role.utils';

export function getGrowthPopupVariant(
  whoAmI: Components.Schemas.WhoAmIDataDto | null,
): Components.Schemas.GrowthPopupVariant | null {
  return getHasTenantOwnerAccess(whoAmI) ? (whoAmI?.growthPopupVariant ?? null) : null;
}
